/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquarePlus = createReactComponent("square-plus", "IconSquarePlus", [
  ["path", { d: "M9 12h6", key: "svg-0" }],
  ["path", { d: "M12 9v6", key: "svg-1" }],
  [
    "path",
    {
      d: "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z",
      key: "svg-2"
    }
  ]
]);

export { IconSquarePlus as default };
//# sourceMappingURL=IconSquarePlus.js.map
